import Vue from "vue";
import VueRouter from "vue-router";
import MapView from "@/views/MapView";
import LayerMenu from "@/components/menu/LayerMenu";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    components: {
      default: MapView,
      menu: LayerMenu
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
